export default {
  primary: '#F27537',
  secondary: '#FDB937',
  white: '#FFFFFF',
  lightGrey: '#F2F2F2',
  darkGrey: '#6F6F6F',
  red: '#E23814',
  blue: '#0000EE',
};
